import { AuthRegex } from '../constants';

export const isEmailValid = (email: string) => {
  const emailRegex = new RegExp(AuthRegex.email, 'gm');
  return emailRegex.test(email);
};

export const isPasswordValid = (password: string) => {
  const passwordRegex = new RegExp(AuthRegex.password, 'gm');
  return passwordRegex.test(password);
};

interface IItemValueValid {
  value: string;
  type?: 'email' | 'password';
  minLength?: number;
}

export function areValuesValid(items: (string | IItemValueValid)[]) {
  return items.every((item: string | IItemValueValid) => {
    if (typeof item === 'string') {
      return item.trim().length > 0;
    }

    if (item.type === 'email') {
      return isEmailValid(item.value);
    }

    if (item.type === 'password') {
      return isPasswordValid(item.value);
    }

    const minLength = item.minLength ?? 1;
    return item.value.trim().length >= minLength;
  });
}
